import { render, staticRenderFns } from "./mainPage.vue?vue&type=template&id=2532e6ae"
import script from "./mainPage.vue?vue&type=script&lang=ts"
export * from "./mainPage.vue?vue&type=script&lang=ts"
import style0 from "./mainPage.vue?vue&type=style&index=0&id=2532e6ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports